import { render, staticRenderFns } from "./report-oms-rf.vue?vue&type=template&id=668a633c&scoped=true"
import script from "./report-oms-rf.vue?vue&type=script&setup=true&lang=js"
export * from "./report-oms-rf.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668a633c",
  null
  
)

export default component.exports